import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import BreadCrumb from "../../components/Breadcrumb";
import FaqItem from "../../components/FaqItem";
import { useDispatch, useSelector } from "react-redux";
import { getFaqs } from "../../actions/settingsActions";
import Loader from "../../components/Loader";
import { FAQ_RETRIEVED } from "../../constants/types/settingsType";
const Faq = () => {
  const [activeSection, setActiveSection] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const faqs = useSelector((state) => state.settings.faqs);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const role = useSelector((state) => state.role.role);
  useEffect(() => {
    let searchLower = searchTerm.toLowerCase();

    let filteredData = faqs
      .map((category) => ({
        ...category,
        questions: category.questions.filter(
          (question) =>
            question.question.toLowerCase().includes(searchLower) ||
            question.answer.toLowerCase().includes(searchLower)
        ),
      }))
      .filter((category) => category.questions.length > 0);
    setFilteredData(filteredData);
  }, [searchTerm]);

  useEffect(() => {
    if (role) {
      let roleValue = role?.val == 6 ? 1 : role?.val;
      dispatch(
        getFaqs(roleValue, () => {
          setIsLoading(false);
        })
      );
      return () => {
        dispatch({ type: FAQ_RETRIEVED, payload: [] });
      };
    }
  }, [role]);

  useEffect(() => {
    setFilteredData(faqs);
  }, [faqs]);
  return (
    <div className="faq-page">
      {isLoading && <Loader />}
      <BreadCrumb pageName="FAQS" />
      <div className="row">
        <div className="col-sm-6">
          <h3 className="page-title">Frequently Asked Questions</h3>
          <p className="page-desc">Questions and answers</p>
        </div>
      </div>
      <div className="container-faq">
        <div className="filter-section">
          <div className="search-bar">
            <FontAwesomeIcon icon={faSearch} />
            <input
              placeholder="Search"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <select
            className="dropdown"
            onChange={(e) => {
              setActiveSection(e.target.value);
            }}
          >
            {role?.val != 3 && <option value="All">All</option>}

            {faqs?.map((category) => (
              <option key={category.fcId}>{category.categoryName}</option>
            ))}
          </select>
        </div>
        {filteredData
          ?.filter(
            (x) => x.categoryName === activeSection || activeSection === "All"
          )
          ?.map((category) => (
            <div className="detail-section" key={category.fcId}>
              <div className="header-section">
                <h1>{category.categoryName}</h1>
                <hr className="line" />
              </div>
              {category?.questions?.map((item) => {
                return (
                  <FaqItem
                    key={item.id}
                    question={item.question}
                    answer={item.answer}
                  />
                );
              })}
            </div>
          ))}
      </div>
    </div>
  );
};

export default Faq;
